module.exports = __webpack_public_path__ + "f075e328eac281c0862613848a1070c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/video-thumbnail-3-navigating-sites.png
// module id = 1937
// module chunks = 0